 
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import getTheme from "../theme";
import i18next from "i18next";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

export const emotionCache = createCache({
  key: "sf",
  nonce: window.__webpack_nonce__,
  stylisPlugins: [
    /* your plugins here */
  ]
});


const CustomTheme = (props) => {
  let theme = getTheme(i18next.dir());
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </CacheProvider>
  );
};

export default CustomTheme;
